<template>
<div class="chapter">
<div class="inner_page">
<div class="otherbooks" id="adc">
<p class="nonindent"><strong>Also by Joy Bauer</strong></p>
<p class="indent">The 90/10 Weight-Loss Plan</p>
<p class="indent">The Complete Idiot’s Guide to Total Nutrition</p>
<p class="extract"><strong>Also by Rosemary Black</strong></p>
<p class="indent">The Kids’ Holiday Baking Book</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429983969_epub_adc_r1.vue?d84f8190